import { IonRow, IonText } from '@ionic/react';

// Style
import styles from '@/components/Loading/Loading.module.css';
import { Spinner } from '@/components/Spinner/Spinner';

import { mergeClassNames } from '@/utils';

import { CustomLoading } from './CustomLoading';

export const Loading = () => {
  return (
    <>
      <IonRow className='ion-justify-content-center' style={{ height: '100%' }}>
        <div className={styles.loadingContainer}>
          <CustomLoading
            iconClassName={mergeClassNames(styles.icon, styles.spin)}
            leadingIcon='spinner'
            message='Loading data, please wait...'
            size='medium'
          />
        </div>
      </IonRow>
    </>
  );
};
